import type { AfventendeIndberetningModel } from "../interfaces/afventendeIndberetning";
import { EfteruddannelsesPeriodeDetail } from "../interfaces/efteruddannelse";
import type { EfteruddannelsesperiodeIndberetningOverviewModel } from "../interfaces/efteruddannelsesperiodeIndberetningOverview";
import { get } from "./util";

export async function getAfventendeIndberetninger() {
  return get<AfventendeIndberetningModel[]>({
    query: "Efteruddannelse/HentAfventendeIndberetninger",
  });
}

export async function getAllEfteruddannelsesperiodeIndberetninger() {
  return get<Array<EfteruddannelsesperiodeIndberetningOverviewModel>>({
    query: "Efteruddannelse/HentAlleEfteruddannelsesperiodeIndberetninger",
  });
}

export async function getEfteruddannelsesPeriode(id: string) {
  return get<EfteruddannelsesPeriodeDetail>({
    query: `Efteruddannelse/HentEfteruddannelsesperiode/${id}`,
  });
}
